<template>
	<!-- <label>{{value}}</label> -->
	<input type="text" :value='value' class='form-control my-control' disabled></input>
</template>

<script>
	import {DB} from './../../../constants'
	const FO = 'get_fo.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'fo',
		data: function () { 
			return {
				value: '',
			}
		},
		methods: {
			fill (id) {
				fetch(DB + FO + '?id=' + id, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.value = data[0].name
					}
					else {
						this.value = ''
					}
				})
				.catch(err => console.log(err))
			}
		},
		props: {
			type: ''
		},
		created: function () {
			EventBus.$on(`${this.type}_region`, id => {
				this.fill(id)
			})
		},
		beforeDestroy () {
			EventBus.$off(`${this.type}_region`)
		}
	}
</script>


// WEBPACK FOOTER //
// fo.vue?4c16bf40